import { ComponentType, FC, useCallback } from "react";
import { BaseLink, useRoute } from "react-router5";
import { sendGtag, useRouteName, useRouteParams } from "./utils";

class Route<P = {}> {

  constructor(name: string, path: string) {
    this.name = name;
    this.path = path;

  }
  
  name: string;
  path: string;
  useIsCurrentRoute = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const route = useRouteName();
    if (route === this.name) {
      return true;
    }
    return false;
  };

  Link: FC<{ href?: string, onClick? : () => void, label?: string} & P> = ({ href, onClick, children, label, ...params }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { router } = useRoute();

    // eslint-disable-next-line react-hooks/rules-of-hooks
    
    return (
      <BaseLink router={router} routeName={this.name} routeParams={params} successCallback={() => {
        onClick?.();
        sendGtag('external', 'click', this.name === 'home' ? 'logo_Avto' : label! )
      }} data-category={'external'} data-action={'click' } data-label={this.name === 'home' ? 'logo_Avto' : label}>
        {children}
      </BaseLink>
    );
  };
}

class ArticleRoute extends Route<{id: number}> {
  defaultParams: {id: number}

  constructor(name: string, path: string, params: {id: number}) {
    super(name, path)
    this.defaultParams = params
  } 
}

export const Home = new Route("home", "/");
export const Article = new ArticleRoute("article", "/article/:id", {id: 1});

const route =
  <R extends Route<any>, >(route: R) =>
  {
      return <P, >(Component: ComponentType<P>) => {
        return (props: P) => {
          const is = route.useIsCurrentRoute();
          const params = useRouteParams();
          if (is) {
            return <Component {...props} {...params} />;
          }
          return <> </>;
        };
      };
    };

export const home = route(Home);
export const article = route(Article);

const routes = [Home, Article];

export default routes;
